<template>
  <div>
    <el-table :data="tableData" border>
      <el-table-column prop="ids" :label="$t('app.common.serialNumber')" align="center" width="60px"></el-table-column>
      <el-table-column prop="userId" :label="$t('app.interReceivedList.table.agent')" align="center" v-show="adminShow"></el-table-column>
      <el-table-column prop="msisdn" label="MSISDN" align="center"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
      <el-table-column prop="content" :label="$t('app.interReceivedList.table.smsContent')" align="center"></el-table-column>
      <el-table-column prop="createTime" :label="$t('app.interReceivedList.table.receiveTime')" align="center"></el-table-column>
    </el-table>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>

</template>
<script>
import { simInterSmsReceivedList } from "@/api/international.js"; //操作记录
export default {
  data() {
    return{
      tableData:[],
      page: 1,
      pageSize: 10,
      total:0,
    }
  },
  computed: {
    adminShow : {
      get() {
        return this.$store.getters.user.userType =='1'
      }
    },
  },
  methods: {
    // 获操操作列表的数据
    initData(){
      let params = {
        model:{
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      simInterSmsReceivedList(params).then(res =>{
        if(res.data.code == 200){
          this.tableData = res.data.data.records;
          this.tableData.map((item,index) => {
            item.ids = index + 1;
          });
          this.total = res.data.data.total;
        }
      })
    },
    // 排序
    compare(property){
      return function(a,b){
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
  },
  created() {
  }
};
</script>

<style scoped lang="less">

</style>


